import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { PageTutorial } from "./PageTutorial";


function TutorialRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <PageTutorial />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default TutorialRegisterPage